import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";
import { Link } from "react-router-dom";

export const FooterSection = styled.footer`
  color: ${themes.colors.white};
  background-color: ${themes.colors.primary};
  background: repeating-linear-gradient(
    -45deg,
    ${themes.colors.secondary},
    ${themes.colors.secondary} 2px,
    ${themes.colors.primary} 2px,
    ${themes.colors.primary} 20px
  );
  padding: 20px 0;
  @media ${device.desktop} {
    padding: 60px 0;
  }
`;

export const Wrap = styled.div`
  margin: 0 20px;
  @media ${device.desktop} {
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const ContentsFlexWrap = styled.div`
  height: 100%;
  gap: 10px;
  background-color: ${themes.colors.background};
  border-radius: 10px;
  padding: 20px;
  @media ${device.desktop} {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    margin-bottom: 131px;
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const LinkListWrap = styled.div`
  @media ${device.desktop} {
    display: flex;
    align-items: center;
    justify-content: space-around;
    justify-content: start;
    gap: 20px;
    position: relative;
    max-width: 1200px;
  }
`;

export const PCLinkListWrap = styled.div`
  display: none;
  @media ${device.desktop} {
    display: flex;
    align-items: center;
    justify-content: space-around;
    justify-content: start;
    gap: 20px;
    position: relative;
    max-width: 1200px;
  }
`;

export const SPLinkListWrap = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 20px;
  @media ${device.desktop} {
    display: none;
  }
`;

export const FooterInformation = styled.div`
  @media ${device.desktop} {
    width: 520px;
  }
`;

export const LogoLink = styled.a`
  font-size: 30px;
  margin: 0;
`;

export const LinkButtonWrap = styled.div`
  margin: 20px 0;
  height: 46px;
  width: 100%;
  max-width: 200px;
  @media ${device.desktop} {
    height: auto;
    width: auto;
    max-width: 220px;
  }
`;

export const NavContentsWrap = styled.div`
  @media ${device.desktop} {
    width: 228px;
  }
`;

export const NavContents = styled.ul`
  box-sizing: border-box;
  list-style: none;
  margin-top: 15px;
  @media ${device.desktop} {
    margin: 0;
  }
`;

export const NavItem = styled.li`
  white-space: nowrap;
  margin-top: 12px;
`;

export const NavItemLink = styled(Link)`
  display: block;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.75;
  font-feature-settings: "palt" 1;
  text-decoration: none;
  color: ${themes.colors.primary};
  transition: color 0.3s ease;
  font-size: ${themes.textSize.s3};
  @media ${device.desktop} {
    font-size: ${themes.textSize.m1};
    padding: 9px 12px;
  }
`;

export const StyledLink = styled.a<{ isline: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isline }) =>
    isline ? "#06c755" : `${themes.colors.filled}`};
  font-weight: bold;
  border-radius: 8px;
  height: 100%;
  padding: 5px 10px;
  white-space: nowrap;
  font-size: ${themes.textSize.m1};
  color: ${themes.colors.white};
  text-decoration: none;
  @media ${device.desktop} {
    width: 198px;
    height: 46px;
    font-size: ${themes.textSize.m2};
    border-radius: 12px;
  }
`;

export const LogoImg = styled.img`
  width: 200px;
`;

export const NumberLabel = styled.label`
  font-size: ${themes.textSize.s1};
  color: ${themes.colors.text};
  text-align: center;
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;
export const CopyLight = styled.label`
  display: block;
  margin: 5px 0 0;
  font-size: ${themes.textSize.s1};
  color: ${themes.colors.text};
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;

export const NumberLabelWrap = styled.div`
  display: none;
  @media ${device.desktop} {
    display: block;
    margin-top: 10px;
  }
`;
export const SPNumberLabelWrap = styled.div`
  margin: 10px 0 0;
  @media ${device.desktop} {
    display: none;
  }
`;
